module.exports = __webpack_public_path__ + "assets/121ae0ff842f4945f863cdcffe4fef0c.mp4";